import { defineMessages } from 'react-intl';

export const customerRatingIconsWithReviewCountMessages = defineMessages({
  ariaLabel: {
    id: 'customerRatings.ratingIconsWithReviewCount.aria.label',
    defaultMessage:
      'Produktbewertung {ratingValue} von {maxRating} Sternen bei {ratingsCount} Bewertungen',
  },
  ariaLabelZero: {
    id: 'customerRatings.ratingIconsWithReviewCount.aria.label.zero',
    defaultMessage: 'noch keine Produktbewertung',
  },
});
